export default {
  state: {
    hasFirstHero: false,
  },
  mutations: {
    SET_PAGE_WITH_HERO(state, value) {
      state.hasFirstHero = value;
    },
  },
};
